module.exports = __webpack_public_path__ + "img/appicon.a4b2975a.png";